(() => {
const root = document.querySelector('[data-zoka-discovery]');
if (!root || root.dataset.initialized) return;
root.dataset.initialized = 'true';
const current = JSON.parse(root.querySelector('[data-discovery-current]').textContent);
let history = [];
try {
 const key='zoka_browsed_products_v1_'+(document.documentElement.lang||'en');
 history=JSON.parse(localStorage.getItem(key)||'[]');
 if(Array.isArray(history)){
 localStorage.setItem(key,JSON.stringify([current,...history.filter(p=>p.id!==current.id)].slice(0,16)));
 }
}catch(e){}

const initializeRows = () => {
const money = cents => {
 const amount = Number(cents) / 100;
 const format = root.dataset.moneyFormat || 'LE {{amount}}';
 const separator = format.match(/\{\{\s*(\w+)\s*\}\}/)?.[1] || 'amount';
 const noDecimals = separator.includes('no_decimals');
 const decimalComma = separator.includes('comma_separator');
 const number = new Intl.NumberFormat(decimalComma ? 'de-DE' : 'en-US', {
  minimumFractionDigits: noDecimals ? 0 : 2, maximumFractionDigits: noDecimals ? 0 : 2
 }).format(amount);
 const markup = format.replace(/\{\{\s*\w+\s*\}\}/, number);
 const text = new DOMParser().parseFromString(markup, 'text/html').body.textContent;
 return text || number;
};
const card = p => {
 const a = document.createElement('a'); a.className='zoka-discovery-card'; a.href=p.url; a.dataset.discoveryId=p.id;
 const media=document.createElement('div');media.className='zoka-discovery-media';
 const img=document.createElement('img');img.src=p.image || p.featured_image;img.alt=p.title;img.loading='lazy';img.width=360;img.height=360;media.append(img);
 const info=document.createElement('div');info.className='zoka-discovery-info';
 const vendor=document.createElement('span');vendor.className='zoka-discovery-vendor';vendor.textContent=p.vendor;
 const h=document.createElement('h3');h.textContent=p.title;
 const prices=document.createElement('div');prices.className='zoka-discovery-price';
 const now=document.createElement('span');now.textContent=money(p.price);
 if(p.compare_at_price>p.price){now.className='is-sale';const old=document.createElement('s');old.textContent=money(p.compare_at_price);prices.append(now,old);}else prices.append(now);
 info.append(vendor,h,prices);a.append(media,info);return a;
};
const fill=(selector,products,requireAvailable=true)=>{
 const section=root.querySelector(selector), row=section.querySelector('.zoka-discovery-row');
 const seen=new Set();
 const chosen=products.filter(p=>p.id!==current.id && (!requireAvailable || p.available!==false) && !seen.has(p.id) && seen.add(p.id)).slice(0,6);
 if(chosen.length){row.replaceChildren(...chosen.map(card));section.hidden=false;}
};
if (Array.isArray(history)) fill('[data-discovery-history]', history, false);
root.querySelectorAll('section').forEach(section=>{
 const row=section.querySelector('.zoka-discovery-row');
 const prev=section.querySelector('[data-discovery-prev]'),next=section.querySelector('[data-discovery-next]');
 if(!prev||!next)return;
 const rtl=getComputedStyle(row).direction==='rtl';
 const sync=()=>{
  const x=Math.abs(row.scrollLeft),max=row.scrollWidth-row.clientWidth;
  prev.disabled=x<2;next.disabled=x>=max-2;
  section.querySelector('.zoka-discovery-controls').hidden=max<2;
 };
 const move=direction=>row.scrollBy({left:direction*(rtl?-1:1)*row.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
 prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
 row.addEventListener('scroll',sync,{passive:true});new ResizeObserver(sync).observe(row);sync();
});
root.querySelectorAll('section').forEach(s=>{
 if(s.querySelector('.zoka-discovery-row').children.length===0 && !s.matches('[data-discovery-history]'))s.hidden=true;
});
};
if ('IntersectionObserver' in window) {
 const observer = new IntersectionObserver(entries => {
  if (!entries.some(entry => entry.isIntersecting)) return;
  observer.disconnect();
  initializeRows();
 }, { rootMargin: '300px' });
 observer.observe(root);
} else initializeRows();
})();
